import { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useKomunikatPowitalny } from '../../../api/domain/komunikaty/queries/useKomunikatPowitalny.jsx'

const LS_KEY = 'komunikat-powitalny-ostatni'

const czyPokazac = (czestotliwoscDni) => {
    if (czestotliwoscDni === -1) return true
    if (czestotliwoscDni === 0) return !sessionStorage.getItem(LS_KEY)
    const ostatni = localStorage.getItem(LS_KEY)
    if (!ostatni) return true
    return Date.now() - Number(ostatni) > czestotliwoscDni * 86400000
}

const zapisz = (czestotliwoscDni) => {
    if (czestotliwoscDni === -1) return
    if (czestotliwoscDni === 0) {
        sessionStorage.setItem(LS_KEY, String(Date.now()))
    } else {
        localStorage.setItem(LS_KEY, String(Date.now()))
    }
}

const ModalKomunikatPowitalny = () => {
    const { data } = useKomunikatPowitalny()
    const [show, setShow] = useState(false)

    useEffect(() => {
        if (data?.aktywny && data?.tresc && czyPokazac(data?.czestotliwosc_dni ?? 0)) {
            setShow(true)
        }
    }, [data])

    const handleClose = () => {
        zapisz(data?.czestotliwosc_dni ?? 0)
        setShow(false)
    }

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Informacje systemowe</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ whiteSpace: 'pre-wrap' }}>{data?.tresc}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalKomunikatPowitalny
